import {base, baseConfig} from '../../Services/api';

export const getShiftCostSummary = (siteId, startDate) => fetch(
  `${base}performance/cost-summary?${new URLSearchParams({siteId, startDate})}`, baseConfig
);

export const getShiftCostRange = (siteId, from, to) => fetch(
  `${base}performance/cost-summary?${new URLSearchParams({siteId, from, to})}`, baseConfig
);
